import { useEffect, useRef } from 'react'
import { RateState } from '../../types'
import IconOvalYellow from '~/assets/images/ovalYellow.png'
import IconOvalRed from '~/assets/images/ovalRed.png'
import styled from 'styled-components'
import refreshLightDot from '~/assets/lottie/refresh-light-dot.json'
import refreshDarkDot from '~/assets/lottie/refresh-dark-dot.json'
import { isDarkThemeName, useThemeName } from '~/theme'
import Lottie from '~/components/Lottie'

export interface Props {
  rateState: RateState
}

const GreenDot: React.FC<Props> = ({ rateState }) => {
  const themeName = useThemeName()
  const animation = isDarkThemeName(themeName) ? refreshDarkDot : refreshLightDot
  const lottieRef = useRef<any>(null)

  const style = {
    width: 18,
    height: 18,
  }
  const options = {
    animationData: animation,
    loop: false,
    autoplay: false,
  }
  // 定时刷新的情况下，rateState 变为 ok 后触发绿灯动画播放，等待动画播放完再更新表单展示数量
  // 其他情况动画展示播放完的状态，也就是绿灯转满一圈
  useEffect(() => {
    if (rateState === RateState.OK) {
      lottieRef.current?.goToAndPlay(0, true)
    }
  }, [rateState])

  const handleDomLoaded = () => {
    const duration = lottieRef.current?.getDuration(true)
    if (typeof duration === 'number') {
      lottieRef.current?.goToAndStop(duration, true)
    }
  }

  return (
    <Lottie
      {...options}
      lottieRef={lottieRef}
      onDOMLoaded={handleDomLoaded}
      style={style}
    />
  )
}

const RateGreenDot: React.FC<Props> = ({ rateState }) => {
  let iconSource = null
  switch (rateState) {
    case RateState.IDLE:
    case RateState.NetworkReason:
      iconSource = IconOvalRed.src
      break
    default:
      iconSource = IconOvalYellow.src
  }

  const showGreenDot =
    rateState === RateState.OK || rateState === RateState.REFRESH_LOADING

  return (
    <div>
      {showGreenDot ? (
        <GreenDot rateState={rateState} />
      ) : (
        <DotIcon src={iconSource} />
      )}
    </div>
  )
}

export default RateGreenDot

const DotIcon = styled.img`
  width: 18px;
  height: 18px;
  cursor: pointer;
`
